import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewRepresentantes from "../views/ViewRepresentantes";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";

const ContainerComponente = styled.div`
  display: grid;
  @media (min-width: 200px) and (max-width: 299px) and (min-height: 200px) and (max-height: 599px) {
    grid-template: 140px 50rem 30rem / auto;
  }
  @media (min-width: 200px) and (max-width: 299px) and (min-height: 600px) and (max-height: 799px) {
    grid-template: 140px 50rem 30rem / auto;
  }
  @media (min-width: 200px) and (max-width: 299px) and (min-height: 800px) {
    grid-template: 140px 50rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 200px) {
    grid-template: 130px 40rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 400px) {
    grid-template: 130px 45rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 600px) {
    grid-template: 130px 50rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 800px) {
    grid-template: 130px 60rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 1000px) {
    grid-template: 130px 70rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 1100px) {
    grid-template: 130px 80rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 1200px) {
    grid-template: 130px 90rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 1300px) {
    grid-template: 130px 100rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 1400px) {
    grid-template: 130px 100rem 30rem / auto;
  }
  @media (min-width: 300px) and (max-width: 399px) and (min-height: 1600px) {
    grid-template: 130px 110rem 30rem / auto;
  }

  @media (min-width: 400px) and (max-width: 499px) and (min-height: 200px) {
    grid-template: 130px 55rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 400px) {
    grid-template: 130px 55rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 600px) {
    grid-template: 130px 50rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 800px) {
    grid-template: 130px 65rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 1000px) {
    grid-template: 130px 70rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 1100px) {
    grid-template: 130px 75rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 1200px) {
    grid-template: 130px 80rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 1300px) {
    grid-template: 130px 90rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 1400px) {
    grid-template: 130px 100rem 30rem / auto;
  }
  @media (min-width: 400px) and (max-width: 499px) and (min-height: 1600px) {
    grid-template: 130px 110rem 30rem / auto;
  }

  @media (min-width: 500px) and (max-width: 699px) and (min-height: 200px) {
    grid-template: 130px 55rem 30rem / auto;
  }
  @media (min-width: 500px) and (max-width: 699px) and (min-height: 400px) {
    grid-template: 130px 55rem 30rem / auto;
  }
  @media (min-width: 500px) and (max-width: 699px) and (min-height: 600px) {
    grid-template: 130px 55rem 30rem / auto;
  }
  @media (min-width: 500px) and (max-width: 699px) and (min-height: 800px) {
    grid-template: 130px 65rem 30rem / auto;
  }
  @media (min-width: 500px) and (max-width: 699px) and (min-height: 1000px) {
    grid-template: 130px 70rem 30rem / auto;
  }
  @media (min-width: 500px) and (max-width: 699px) and (min-height: 1100px) {
    grid-template: 130px 75rem 30rem / auto;
  }
  @media (min-width: 500px) and (max-width: 699px) and (min-height: 1200px) {
    grid-template: 130px 80rem 30rem / auto;
  }
  @media (min-width: 500px) and (max-width: 699px) and (min-height: 1300px) {
    grid-template: 130px 90rem 30rem / auto;
  }
  @media (min-width: 500px) and (max-width: 699px) and (min-height: 1400px) {
    grid-template: 130px 100rem 30rem / auto;
  }
  @media (min-width: 500px) and (max-width: 699px) and (min-height: 1600px) {
    grid-template: 130px 110rem 30rem / auto;
  }

  @media (min-width: 700px) and (max-width: 899px) and (min-height: 200px) {
    grid-template: 130px 55rem 30rem / auto;
  }
  @media (min-width: 700px) and (max-width: 899px) and (min-height: 400px) {
    grid-template: 130px 55rem 30rem / auto;
  }
  @media (min-width: 700px) and (max-width: 899px) and (min-height: 600px) {
    grid-template: 130px 55rem 30rem / auto;
  }
  @media (min-width: 700px) and (max-width: 899px) and (min-height: 800px) {
    grid-template: 130px 60rem 30rem / auto;
  }
  @media (min-width: 700px) and (max-width: 899px) and (min-height: 1000px) {
    grid-template: 130px 80rem 40rem / auto;
  }
  @media (min-width: 700px) and (max-width: 899px) and (min-height: 1200px) {
    grid-template: 130px 90rem 30rem / auto;
  }
  @media (min-width: 700px) and (max-width: 899px) and (min-height: 1400px) {
    grid-template: 130px 100rem 30rem / auto;
  }
  @media (min-width: 700px) and (max-width: 899px) and (min-height: 1600px) {
    grid-template: 130px 110rem 30rem / auto;
  }

  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 200px) {
    grid-template: 130px 55rem 30rem / auto;
  }
  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 400px) {
    grid-template: 130px 55rem 30rem / auto;
  }
  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 600px) {
    grid-template: 130px 55rem 30rem / auto;
  }
  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 800px) {
    grid-template: 130px 60rem 30rem / auto;
  }
  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 1000px) {
    grid-template: 130px 70rem 30rem / auto;
  }
  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 1200px) {
    grid-template: 130px 90rem 30rem / auto;
  }
  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 1400px) {
    grid-template: 130px 100rem 30rem / auto;
  }
  @media (min-width: 900px) and (max-width: 1099px) and (min-height: 1600px) {
    grid-template: 130px 110rem 30rem / auto;
  }
  @media (min-width: 1100px) and (min-height: 200px) {
    grid-template: 100px 60rem 30rem / auto;
  }
  @media (min-width: 1100px) and (min-height: 600px) {
    grid-template: 100px 60rem 30rem / auto;
  }
  @media (min-width: 1100px) and (min-height: 800px) {
    grid-template: 100px 60rem 30rem / auto;
  }
  @media (min-width: 1100px) and (min-height: 1000px) {
    grid-template: 100px 70rem 30rem / auto;
  }
  @media (min-width: 1100px) and (min-height: 1200px) {
    grid-template: 100px 90rem 30rem / auto;
  }
  @media (min-width: 1100px) and (min-height: 1400px) {
    grid-template: 100px 100rem 30rem / auto;
  }
  @media (min-width: 1100px) and (min-height: 1600px) {
    grid-template: 100px 120rem 30rem / auto;
  }
`;

const Representantes: React.FC = () => (
  <>
    <ContainerComponente>
      <ViewAppBar />
      <ViewRepresentantes />
      <ViewFooter />
    </ContainerComponente>
  </>
);
export default Representantes;
